export function zeroPad(number: number) {
  return ('0' + number).slice(-2)
}
